/**
 * @fileoverview Layout column component React interface.
 * @author Lisa Liu (lliu@yext.com)
 */
// @ts-nocheck
goog.declareModuleId('yext.ui.components.layout.Column');

import {classNames} from '/ui/lib/classnames';

const colRoot = 'col-sm';
const columnClassMapping = {
  'fullWidth': '12',
  'oneHalf': '6',
  'oneQuarter': '3',
  'threeQuarters': '9',
  'oneThird': '4',
  'twoThirds': '8',
  'auto': null,
};

/**
 * @param {{children: (React.ReactNode|undefined),
 *          columnClasses: (Array<string>|string|undefined),
 *          size:(string|undefined)
 *        }} props
 * @returns {?}
 */

/**
 * @deprecated
 * @suppress {checkTypes}
 * @param {?} props
 * @return {React.ReactElement}
 */
export function Column({
  size,
  columnClasses,
  children,
}) {
  const columns = columnClassMapping[size] === null ? '' : `-${columnClassMapping[size]}`;

  const colClasses = classNames(
    `${colRoot}${columns}`,
    columnClasses,
  );

  return (
    <div className={colClasses}>
      {children}
    </div>
  );
}
